import { Formik, Field, Form, ErrorMessage } from 'formik';
import { maxLength, minLength, required, requiredNumber, schemaValidate, rangeNumber } from '../../../../helpers/validation-helpers';
import FormErrorMessage from '../../../common/form-elements/form-error-message/form-error-message';
import Input from '../../../common/form-elements/input/input';
import Select from 'react-select';

const NetworkToolsConfigForm = ({
    initialValues,
    onFormSubmit,
    onCancel,
    pingPacketSizeOptions
}) => {
    const handleFormFieldChange = (field, props) => (value) => {
        props.setFieldValue(field, value);
    };

    const handlePingEchoCountChange = (field, props) => value => {
        if (!value) {
            props.setFieldValue(field, 0);
            return;
        }
        props.setFieldValue(field, (value * 1).toString());
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onFormSubmit}
        >
            {(props) => (
                <Form>
                    <div className="glu-modal__body">
                        <div className="glu-content__section">
                            <div className="glu-form-row">
                                <div className="glu-label">Widget Title</div>
                                <Field
                                    as={Input}
                                    autoFocus
                                    name="title"
                                    className="glu-form-input-pad"
                                    onChange={props.handleChange('title')}
                                    validate={schemaValidate(
                                        [required(), minLength(), maxLength(30)]
                                    )}
                                    invalid={props.errors.title && props.touched.title}
                                />
                                <ErrorMessage name="title" component={FormErrorMessage} />
                            </div>
                            <div className="glu-form-row">
                                <div className="glu-label">Number of ping echo requests</div>
                                <Field
                                    as={Input}
                                    type="number"
                                    name="pingEchoCount"
                                    className="glu-form-input-pad"
                                    onChange={handlePingEchoCountChange('pingEchoCount', props)}
                                    validate={schemaValidate(
                                        [requiredNumber(),
                                          rangeNumber(1,
                                            50,
                                            'Number of ping Echo requests must be from 1 to 50')]
                                    )}
                                    invalid={props.errors.pingEchoCount && props.touched.pingEchoCount}
                                />
                                <ErrorMessage name="pingEchoCount" component={FormErrorMessage} />
                            </div>
                            <div className="glu-form-row">
                                <div className="glu-label">Ping packet size</div>
                                <Field
                                    as={Select}
                                    name="pingPacketSize"
                                    options={pingPacketSizeOptions}
                                    isSearchable={false}
                                    value={props.values.pingPacketSize}
                                    onChange={handleFormFieldChange('pingPacketSize', props)}
                                    className="glu-select glu-form-input-pad"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div>
                    </div>
                    <footer className="glu-modal__footer">
                        <div className="glu-flex-grow glu-flex-row">
                            <div className="glu-flex-grow text-right">
                                <button
                                    onClick={onCancel}
                                    className="glu-btn glu-btn--secondary"
                                    type="button"
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="glu-flex-shrink">
                                <button
                                    type="submit"
                                    className="glu-btn glu-btn--primary"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </footer>
                </Form>
            )}
        </Formik>
    );;
};

export default NetworkToolsConfigForm;
